import { router, usePage } from '@inertiajs/vue3';

/**
 * Props that drive the "Subscription details" card on the billing pages. The
 * PRO/Team page and the Plugin page each expose their own subset, so the list
 * is filtered against the page that is actually open rather than hardcoded per
 * dialog - a hardcoded list silently leaves every other page unrefreshed.
 */
const SUBSCRIPTION_PROPS = [
    'proSubscription',
    'isTrialingPro',
    'hasLegacySubscription',
    'pluginSubscription',
    'shouldAllowTrial',
];

/**
 * Refreshes the subscription props of whichever billing page is currently open.
 *
 * A purchase is finalized by a separate request that runs *after* the Inertia
 * visit which created it, so the props rendered by that visit are always stale.
 * This is a partial reload on purpose: refetching the whole page would swap
 * plans, countries, billing address and invoices too, re-rendering (and
 * visibly flickering) parts of the page that the purchase did not change.
 */
export const refreshBillingPage = (): void => {
    const pageProps = usePage().props ?? {};
    const only = SUBSCRIPTION_PROPS.filter((prop) => prop in pageProps);

    if (only.length === 0) {
        return;
    }

    router.reload({ only, preserveScroll: true });
};

export const useBillingRefresh = () => ({ refreshBillingPage });

export default useBillingRefresh;
